import { render } from "./ChooseCustomRoutePage.vue?vue&type=template&id=f635f738&ts=true"
import script from "./ChooseCustomRoutePage.vue?vue&type=script&lang=ts"
export * from "./ChooseCustomRoutePage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__